export default {
    'diagram7-5c': {
      'title': `Please drag and drop the elements of the problem definition into their correct positions in the framework. There may be more than one element for each position`,
      'structure-answers-title': `Elements of the problem definition`,
      'answers': {
        'r1-bottom': 'Don\'t have resources to build, staff, manage new facility',
        'r2-bottom': 'Seamless addition to operations',
        'r2-bottom-2': 'Minimum disruption',
        'solution-bottom': 'Hire an outside company to build, staff, and manage the project'
      },
      'exercise-title': 'PROPOSAL TO SPIRIT – PROBLEM'
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/5/5c/diagram7/i18n/en.js